<template>
    <div class="detail">
        <div class="top-content main_content">
            <TopMenus v-model="activeIndex"></TopMenus>
        </div>
        <div class="banner-box">
            <div class="main_content banner-content">
                <div class="banner">
                    <el-carousel indicator-position="outside" arrow="always" height="338rem">
                        <el-carousel-item class="carousel-item">
                            <img src="./images/1.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/2.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/3.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/4.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/5.png" alt="img"/>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="info">
                    <div class="title">快麦<span class="other-color">DP158</span>系列云小票机</div>
                    <div class="sub-title">WiFi+来单滴滴语音+手动撕纸</div>
                    <div class="text">
                        通讯接口：WiFi<br/>
                        打印速度：90mm/s<br/>
                        打印宽度：48mm<br/>
                        适用：外卖、零售、餐饮等打印小票
                    </div>
                </div>
            </div>
        </div>
        <template v-if="activeIndex===0">
            <div class="main_content content-bg">
                <img src="./images/dp158_02.jpg" alt="bg">
                <img src="./images/dp158_03.jpg" alt="bg">
                <img src="./images/dp158_04.jpg" alt="bg">
                <img src="./images/dp158_05.jpg" alt="bg">
                <img src="./images/dp158_06.jpg" alt="bg">
                <img src="./images/dp158_07.jpg" alt="bg">
                <img src="./images/dp158_08.jpg" alt="bg">
                <img src="./images/dp158_09.jpg" alt="bg">
                <img src="./images/dp158_10.jpg" alt="bg">
                <img src="./images/cp.jpg" alt="bg">
            </div>
        </template>
        <div v-else-if="activeIndex===1" class="content-bg-cs">
            <img style="display: block;width: 1300rem;margin: 0 auto;" src="./images/DP158.jpg" alt="">
        </div>
    </div>
</template>

<script>
import TopMenus from '@/views/printCenter/TopMenus.vue'

export default {
    name: "deviceDetail",
    components: {TopMenus},
    data() {
        return {
            activeIndex: 0
        };
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../printCenter.scss";

.detail {
    .content-bg {
        img {
            width: 100%;
        }
    }

    .content-bg-cs {
    }
}
</style>
